import React from "react";
import { Card, Text } from "rebass";
import { FaExclamationTriangle } from "react-icons/fa";

import { createIconName } from "../../../utils/createIconName";

import SIZES from "./settings";

interface IProps {
  variant: "sm" | "md" | "lg";
  title?: string;
  coverImagePath?: string;
}

export function RecordIcon({ variant, title, coverImagePath }: IProps) {
  const { size, borderRadius, fontSize } = SIZES[variant];

  return (
    <Card
      width={`${size}px`}
      height={`${size}px`}
      borderRadius={`${borderRadius}px`}
      backgroundColor="#f9eff6"
      backgroundImage={coverImagePath && `url(${coverImagePath})`}
      backgroundPosition="center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      css="display: flex; justify-content: center; align-items: center; overflow: hidden;"
    >
      {
        !coverImagePath && (
          <Text
            fontSize={`${fontSize}rem`}
            fontWeight="bold"
            color={title ? "wild-blue" : "orange-50"}
            css="text-transform: uppercase;"
          >
            {
              title
                ? createIconName(title)
                : <FaExclamationTriangle size={size / 2} display="block" />
            }
          </Text>
        )
      }
    </Card>
  );
}
